module.exports = __webpack_public_path__ + "img/model_mv750m_small.d24e45de.png";